export default __webpack_public_path__ + "static/media/rhino.dcfae07f.jpeg";